import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild{
  constructor(
    private oidcSecurityService: OidcSecurityService,
  ) {}

  canActivate(): Observable<boolean> {
      return this.oidcSecurityService.checkAuthIncludingServer().pipe(
        tap(({ isAuthenticated }) => {
          if (!isAuthenticated) {
            // Keine gültige Session → starte Login
            this.oidcSecurityService.authorize();
          }
        }),
        map(({ isAuthenticated }) => isAuthenticated),
        take(1)
      ); 
  }

  canActivateChild(
  ) {
    return this.canActivate();
  }
}